export const OPTIONS_STATUS_EDIT_TIPE_PELUNASAN = [
  { value: '', text: 'Semua Status' },
  { value: 0, text: 'Pending' },
  { value: 1, text: 'Disetujui' },
  { value: 2, text: 'Ditolak' },
];

export const OPTIONS_LIMIT_PAGINATION = [
  { value: 10, text: '10'},
  { value: 20, text: '20'},
  { value: 30, text: '30'},
  { value: 40, text: '40'},
  { value: 50, text: '50'},
];

export const OPTIONS_TIPE_PELUNASAN = [
  { value: null, text: '-- Pilih Tipe --' },
  { value: 1, text: 'Nasabah + SBG' },
  { value: 2, text: 'Nasabah + Nota Hilang' },
  { value: 3, text: 'Pelunasan Diwakilkan + SBG' },
  { value: 4, text: 'Pelunasan Diwakilkan + Surat Kuasa PGI (Apabila SBG Hilang)' },
];

export const OPTIONS_STATUS_APPROVAL_DISBURSEMENT = [
  { value: 0, text: 'PENDING' },
  { value: 1, text: 'APPROVED' },
  { value: 2, text: 'REJECTED' },
  { value: 10, text: 'CANCELLED' },
];

export const OPTIONS_STATUS_APPROVAL_EDIT_NASABAH = [
  {
    value: '',
    text: 'Semua'
  },
  {
    value: 0,
    text: 'PENDING'
  },
  {
    value: 1,
    text: 'DISETUJUI'
  },
  {
    value: 2,
    text: 'DITOLAK'
  },
];

export const OPTIONS_TIPE_EDIT_NASABAH = [
  {
    value: '',
    text: 'Semua'
  },
  {
    value: 'nama',
    text: 'Nama'
  },
  {
    value: 'no_handphone_sekarang',
    text: 'No Handphone'
  },
];